import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import moment from 'moment';
import ShopPayoutCreateEditForm from './Components/ShopPayoutCreateEditForm';
import ShopPayoutApi from './ShopPayoutApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: ShopPayoutCreateEditForm,
                getCreate: ShopPayoutApi.create,
                getClone: ShopPayoutApi.getOne,
                defaults: { period: moment().toJSON() },
                successMessage: "Payout List Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}